// import React from "react";

// import { Grid } from "@mui/material";
// import CustomTable from "../../../../Components/Table/CustomTable";
// import RegistrationDetailsModal from "../Modal/RegistrationDetailsModal";

// const RegistrationApproved = () => {
//   const tableData = [
//     {
//       Name: "Vallarasu",
//       Email: "valla@gmail.com",
//       MobileNumber: "1232343444",
//       UserType: "Financial Consultant",
//       Status: "Approved",
//     },
//     {
//       Name: "Pravin",
//       Email: "pravin@gmail.com",
//       MobileNumber: "98787687687",
//       UserType: "Financial Consultant",
//       Status: "Approved",
//     },
//     {
//       Name: "Shahul",
//       Email: "shahul@gmail.com",
//       MobileNumber: "123322443543",
//       UserType: "Financial Consultant",
//       Status: "Approved",
//     },
//     {
//       Name: "Ramesh",
//       Email: "Ramesh@gmail.com",
//       MobileNumber: "76575675664",
//       UserType: "Financial Consultant",
//       Status: "Approved",
//     },
//     {
//       Name: "Sanjeev",
//       Email: "Sanjeev@gmail.com",
//       MobileNumber: "909878789709",
//       UserType: "Financial Consultant",
//       Status: "Approved",
//     },
//   ];
//   const tableHeadData = [
//     "S.No",
//     "Name",
//     "Email",
//     "Mobile Number",
//     "User Type",
//     "Status",
//   ];
//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={12} sx={{ width: "100px" }}>
//         <CustomTable
//           tableData={tableData}
//           title="User Roles"
//           tableView="tableView"
//           tableHeadData={tableHeadData}
//           dataCreate="dataCreate"
//           // title="Registration Approval"
//           // modalHeadingName="Create User Role"
//           modalVeiwName={RegistrationDetailsModal}
//           ModalViewComponent1="ModalViewComponent"
//           modalViewHeadingName="User Detail"
//           modalHeadingName="Registration Details"
//         />
//       </Grid>
//     </Grid>
//   );
// };

// export default RegistrationApproved;


import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import CustomTable from "../../../../Components/Table/CustomTable";
import RegistrationDetailsModal from "../Modal/RegistrationDetailsModal";
import actions from "../../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderName, setSubHeaderName } from "../../../../ReduxStore/Slices/headerSlice";

const RegistrationApproved = () => {
  const tableData = [
    {
      Name: "Vallarasu",
      Email: "valla@gmail.com",
      MobileNumber: "1232343444",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
    {
      Name: "Pravin",
      Email: "pravin@gmail.com",
      MobileNumber: "98787687687",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
    {
      Name: "Shahul",
      Email: "shahul@gmail.com",
      MobileNumber: "123322443543",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
    {
      Name: "Ramesh",
      Email: "Ramesh@gmail.com",
      MobileNumber: "76575675664",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
    {
      Name: "Sanjeev",
      Email: "Sanjeev@gmail.com",
      MobileNumber: "909878789709",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
  ];
  const tableHeadData = [
    "S.No",
    "Name",
    "Email",
    "Mobile Number",
    "User Type",
    "Creator Role",
    "Creator Name",
    "Status",
  ];


 const dispatch=useDispatch()  
  const { getAllApprovedCustomersWithCreatorAndApprover } = useSelector(
    (state) => state?.getAllApprovedCustomersWithCreatorAndApprover
  );

  console.log(
    getAllApprovedCustomersWithCreatorAndApprover?.data,
    "getAllApprovedCustomersWithCreatorAndApprover"
  );

  const { approveCustomer } = useSelector((state) => state?.approveCustomer);

  const { managementRegisterForCustomer } = useSelector(
    (state) => state?.managementRegisterForCustomer
  );
  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllApprovedCustomersWithCreatorAndApprover`,
      };
      await dispatch(actions.GETALLAPPROVEDCUSTOMERSWITHCREATORANDAPPROVER(data1));
    };
    fetchData();
  }, [dispatch,approveCustomer]);

  const [rowTableData, setRowTableData] = useState([
    {
      Name: "--",
      customer_id: "--",
      email: "--",
      phone: "--",
      role: "--",
      approval_status: "--",
    },
  ]);
  console.log(rowTableData,"rowTableDatarowTableData")

  useEffect(() => {
    const tempArr = [];
    console.log(getAllApprovedCustomersWithCreatorAndApprover,'getAllApprovedCustomersWithCreatorAndApprovergetAllApprovedCustomersWithCreatorAndApprover')

    getAllApprovedCustomersWithCreatorAndApprover?.data?.map((data, index) => {
      return tempArr.push({
        Name: `${data?.first_name} ${data?.last_name}`,
        customer_id: data?.customer_id,
        email: data?.email,
        phone: data?.phone,
        role: data?.role === "customer" ? "Individual" : data?.role,
        creatorName: data?.creator===null ? "Self" : data?.creator?.name,
        creatorRole: data?.creatorRole===null ? "Self" : data?.creatorRole?.roleName,
        approval_status:
         `${data?.approval_status?.charAt(0).toUpperCase() +
          data?.approval_status?.slice(1)} by ${data?.approverRole?.roleName}`,
      });
    });
    setRowTableData(tempArr);
  }, [getAllApprovedCustomersWithCreatorAndApprover]);

  React.useEffect(() => {
      dispatch(setHeaderName("Registration Approval"));
      dispatch(setSubHeaderName(""));
    }, [dispatch]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          title="Registration Approval"
          tableView="tableView"
          tableHeadData={tableHeadData}
          // dataCreate="dataCreate"
          modalVeiwName={RegistrationDetailsModal}
          ModalViewComponent1="ModalViewComponent"
          modalViewHeadingName="User Detail"
          modalHeadingName="Registration Details"
        />
      </Grid>
    </Grid>
  );
};

export default RegistrationApproved;
